import { render, staticRenderFns } from "./WealthStatementRow.vue?vue&type=template&id=76c12834&scoped=true&"
import script from "./WealthStatementRow.vue?vue&type=script&lang=ts&"
export * from "./WealthStatementRow.vue?vue&type=script&lang=ts&"
import style0 from "./WealthStatementRow.vue?vue&type=style&index=0&id=76c12834&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c12834",
  null
  
)

export default component.exports